__turbopack_context__.v({
  "container": "joAiqa_container",
  "icon": "joAiqa_icon",
  "text": "joAiqa_text",
});
